<script>
import { CARD_ART_HEIGHT } from '../ui/art';

export default {
  name: 'ArtError',
  data() {
    return {
      CARD_ART_HEIGHT
    };
  }
};
</script>

<template>
  <img src="/add-to-transcript/art-error.png" :height="CARD_ART_HEIGHT" />
</template>
